// API da tela de Pendências (união conferencia_nfe ∪ conferencia_pendencia) — espelha
// backend/Controllers/ConferenciaPendenciaController.cs. Mesmo molde de api/conferencia.ts:
// resposta crua, sem envelope {success,data}.
import api from './client';
import type {
  ConferenciaListItem,
  ConferenciaNfe,
  ConferenciaNfeFoto,
  ListarConferenciasFiltros,
  OcorrenciaConferencia,
  RegistrarOcorrenciaRequest,
} from '../types/conferencia';

const BASE = '/conferencia-pendencia';

export const conferenciaPendenciaApi = {
  /** Lista cabeçalhos filtrados por pendência (default do backend: "com_pendencia"). */
  listar: (filtros: ListarConferenciasFiltros = {}) => {
    const params = new URLSearchParams();
    if (filtros.pendencia) params.append('pendencia', filtros.pendencia);
    if (filtros.periodoIni) params.append('periodoIni', filtros.periodoIni);
    if (filtros.periodoFim) params.append('periodoFim', filtros.periodoFim);
    if (filtros.setor) params.append('setor', filtros.setor);
    if (filtros.busca) params.append('busca', filtros.busca);

    const queryString = params.toString();
    return api.get<ConferenciaListItem[]>(`${BASE}${queryString ? `?${queryString}` : ''}`);
  },

  /** Detalhe (cabeçalho + itens) de uma conferência. */
  obter: (id: number) => api.get<ConferenciaNfe>(`${BASE}/${id}`),

  /** Linha do tempo completa (manual + sistema) em ordem cronológica. */
  listarOcorrencias: (id: number) => api.get<OcorrenciaConferencia[]>(`${BASE}/${id}/ocorrencias`),

  /** Adiciona uma entrada manual na linha do tempo — colaboração, não exige conferencia_pendencia. */
  registrarOcorrencia: (id: number, body: RegistrarOcorrenciaRequest) =>
    api.post<OcorrenciaConferencia>(`${BASE}/${id}/ocorrencias`, body),

  // ── Fotos (reúso do acervo da conferência, acessível à união) ──────────

  /** Metadados das fotos da conferência (sem os bytes). */
  listarFotos: (id: number) => api.get<ConferenciaNfeFoto[]>(`${BASE}/${id}/fotos`),

  /** Bytes da foto via axios autenticado — mesmo idiom de conferenciaApi.baixarFoto. */
  baixarFoto: async (anexoId: number): Promise<Blob> => {
    const response = await api.get(`${BASE}/fotos/${anexoId}`, { responseType: 'blob' });
    return response.data;
  },

  /** Anexa uma foto (multipart) à conferência. */
  enviarFoto: (id: number, arquivo: File) => {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return api.post<ConferenciaNfeFoto>(`${BASE}/${id}/fotos`, form);
  },

  // ── Tratar: aperta pra conferencia_pendencia no backend ─────────────────

  /** Marca a pendência declarada na conclusão como resolvida (registra quem e quando). */
  resolver: (id: number, observacao?: string) =>
    api.post<ConferenciaNfe>(`${BASE}/${id}/resolver`, { observacao }),
};

export default conferenciaPendenciaApi;
